import { Heading, List, Text } from '@ksyos/design-system';
import { CollapseCard } from './CollapseCard';

export function ToGeneralInfoCard() {
    return (
        <CollapseCard title="Ksyos Oogheelkunde">
            <Heading
                mb={2}
                size="small"
            >
                Wat is het?
            </Heading>
            <Text>
                Met Ksyos Oogheelkunde werken oogartsen, optometristen en huisartsen samen om oogzorg te bieden. Dit
                gebeurt dicht bij huis en zonder wachttijden. Een oogarts kijkt op afstand mee en geeft advies.
            </Text>
            <Heading
                mb={2}
                mt={3}
                size="small"
            >
                Hoe werkt het?
            </Heading>
            <Text mb={3}>
                Je gaat naar een optometrist in de buurt voor een oogonderzoek. Dit onderzoek bestaat uit:
            </Text>
            <List styleType="bullet">
                <List.Item>Vragen over je klachten en gezondheid</List.Item>
                <List.Item>Testen van je zicht</List.Item>
                <List.Item>Oogmeting</List.Item>
                <List.Item>Foto&apos;s van het netvlies</List.Item>
                <List.Item>Meting van de oogdruk</List.Item>
            </List>
            <Text mt={3}>
                Als er afwijkingen worden gevonden, kan extra onderzoek nodig zijn. De resultaten worden naar de oogarts
                gestuurd, maar alleen wanneer dit nodig is. Binnen twee werkdagen geeft de oogarts advies. Als het nodig
                is bespreekt de optometrist dit met jou en maakt een vervolgafspraak. Je huisarts ontvangt ook de
                uitslag.
            </Text>
            <Heading
                mb={2}
                mt={3}
                size="small"
            >
                Vergoeding
            </Heading>
            <Text>
                Ksyos stuurt de rekening naar je zorgverzekeraar. Het kan zijn dat je een deel zelf moet betalen vanwege
                je eigen risico.
            </Text>
        </CollapseCard>
    );
}
